// extracted by mini-css-extract-plugin
export default {"policyContainer":"Policies_policyContainer__FBEoJ","wrapper":"Policies_wrapper__IUYI8"};